import md from '@/routes/middlewares';

import labWorkOrderView from '@/views/laboratory/workOrder/LabWorkOrderView.vue';

const workOrder = {
    path: 'labWorkOrders/:labWorkOrderId',
    component: labWorkOrderView,
    name: 'labWorkOrderView',
    meta: {
        middlewares: [
            md.getLabWorkOrder,
        ],
    },
};

export default workOrder;
